module.exports = __webpack_public_path__ + "static/media/i4.8d560f3d.jpg";